import { faBell, faCheckCircle, faLeftRight, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProfileMenu from "components/ProfileMenu";
import ActionDialog from "components/reusable/ActionDialog";
import BottomSheet from "components/reusable/BottomSheet";
import QRScanner from "components/reusable/QRScanner";
import AuthContext from "context/AuthContext";
import { Button } from "flowbite-react";
import useToastContext from "hooks/useToastContext";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import { default as BottomNav } from "../../components/BottomNav";
import AddWallet from "./AddWallet/AddWallet";

function DashboardMobile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const notification = useToastContext();

  const [showSwitchWallet, setShowSwitchWallet] = useState(false);
  const [switchWalletContextId, setSwitchWalletContextId] = useState(null);
  const [showProfileBottomSheet, setShowProfileBottomSheet] = useState(false);

  const walletScrollRef = useRef(null);
  const [walletActiveIndex, setWalletActiveIndex] = useState(0);

  const { language, user, wallets, getProfile, hasNewNotification, storeTokens } = useContext(AuthContext);

  useEffect(() => {
    scrollToWallet((wallets || []).map((it) => it._id).indexOf(user.wallet_id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallets]);

  useEffect(() => {
    const el = walletScrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const idx = Math.round(el.scrollLeft / el.clientWidth);
      setWalletActiveIndex(idx);
    };

    el.addEventListener("scroll", handleScroll, { passive: true });
    return () => el.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onWalletCreated = async () => {
    getProfile();
  };

  const walletClicked = async (id) => {
    if (user.wallet_id === id) {
      navigate("/my-wallet");
    } else {
      setSwitchWalletContextId(id);
      setShowSwitchWallet(true);
    }
  };

  const selectUserWallet = async (id) => {
    try {
      const path = pathObj.changeUserWallet;
      var res = await apiPost(path, { id });
      storeTokens(res.data.results.token, res.data.results.refresh_token);
      setShowSwitchWallet(false);
    } catch (error) {}
  };

  const scrollToWallet = async (i) => {
    if (!walletScrollRef.current) return;
    const el = walletScrollRef.current;
    el.scrollTo({
      left: el.clientWidth * i,
      behavior: "smooth",
    });
  };

  const [showScanner, setShowScanner] = useState(false);
  const handleScanResult = (result) => {
    setShowScanner(false);
    const scanData = result[0].rawValue;
    if (!scanData) {
      notification.error({ message: t("SCAN_FAILED") });
      return;
    }

    //TODO LATER?
  };

  const [showPostaShqiptareAlertDialog, setShowPostaShqiptareAlertDialog] = useState(false);

  return (
    <>
      <div>
        <div className="flex h-[3rem] justify-between items-center m-4">
          <img className="h-[3rem] cursor-pointer hidden dark:block" src="images/whitelogo.svg" alt="LOGO" />
          <img className="h-[3rem] cursor-pointer block dark:hidden" src="images/logo.svg" alt="LOGO" />
          <div className="flex gap-2 items-center">
            <div className="relative">
              <FontAwesomeIcon icon={faBell} size="2xl" className="cursor-pointer" onClick={() => navigate("/notifications")} />
              {hasNewNotification && <div className="w-2 h-2 bg-red-500 rounded-full absolute top-[0.2rem] right-[0.4rem]"></div>}
            </div>
            <img
              className="w-12 h-12 rounded-full cursor-pointer object-cover"
              onClick={() => {
                setShowProfileBottomSheet(true);
              }}
              src={user.profile_pic}
              alt=""
            />

            {showProfileBottomSheet && (
              <BottomSheet
                open={showProfileBottomSheet}
                onClose={() => {
                  setShowProfileBottomSheet(false);
                }}
                showHeader={false}
              >
                <ProfileMenu
                  onClose={() => {
                    setShowProfileBottomSheet(false);
                  }}
                />
              </BottomSheet>
            )}
          </div>
        </div>

        <div className="flex w-full justify-center ">
          <div className="container grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="col-span-1 mx-4">
              <div ref={walletScrollRef} className="relative flex gap-2 mt-5 overflow-x-auto no-scrollbar w-full snap-x snap-mandatory">
                {(wallets || []).map((it, idx) => (
                  <div className="snap-center shrink-0 w-full">
                    <div
                      className="bg-card mx-1 text-white p-[1rem] cursor-pointer"
                      onClick={() => {
                        walletClicked(it._id);
                      }}
                    >
                      <div className="flex w-full justify-between items-center">
                        <img src="images/whitelogo.svg" className="h-[1.5rem]" alt="LOGO" />
                        <span className="font-medium">{it.wallet_number}</span>
                      </div>
                      <div className="font-medium mt-6 ms-1">{t("BALANCE")}</div>
                      <div className="font-bold text-2xl ms-1">
                        {it.wallet_currency} {it.wallet_amount}
                      </div>
                      <div className="flex justify-between items-center mt-6 ms-1">
                        <div className="font-medium">{it.wallet_description}</div>
                        {user.wallet_id === it._id && (
                          <Button className="flex gap-2 bg-card px-2 py-1">
                            <FontAwesomeIcon icon={faCheckCircle} className="card-icon" />
                            {t("SELECTED")}
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                <AddWallet onCreate={onWalletCreated} />
              </div>
              <div className="flex justify-center gap-2 mt-4">
                {Array.from({ length: (wallets || []).length + 1 }).map((it, idx) => (
                  <div
                    key={idx}
                    onClick={() => scrollToWallet(idx)}
                    className={`transition-all rounded-full cursor-pointer 
                      ${idx === walletActiveIndex ? "w-6 h-2 bg-primary" : "w-2 h-2 bg-gray-400"}
                    `}
                  />
                ))}
              </div>
            </div>
            <div className="col-span-1">
              <div className="grid grid-cols-2 gap-4 p-3 mx-4">
                <Button
                  className="bg-card p-2 h-[4.5rem] gap-2 col-span-1 py-5 rounded-3xl"
                  onClick={() => {
                    navigate("/add-money");
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} className="card-icon" />
                  <span className="text-lg font-medium">{t("O_ADD_MONEY")}</span>
                </Button>
                <Button
                  className="bg-card p-2 h-[4.5rem] gap-2 col-span-1 rounded-3xl"
                  onClick={() => {
                    navigate("/transfer-money");
                  }}
                >
                  <FontAwesomeIcon icon={faLeftRight} className="card-icon" />
                  <span className="text-lg font-medium">{t("DASHBOARD_TRANSFER_MONEY")}</span>
                </Button>
              </div>
              <div className="mt-3 p-4 bg-backdrop rounded-3xl pb-[6rem] md:pb-0">
                <div className="mt-2">
                  <span className="text-lg mx-2 font-medium">{t("O_OFFERS_AND_PROMO_CODES")}</span>
                  <img
                    className="mt-2 p-2 rounded-3xl aspect-16/9 w-full cursor-pointer"
                    alt="Post"
                    src={language === 1 ? "./images/promotions/post_en.png" : "./images/promotions/post_al.png"}
                    onClick={() => {
                      setShowPostaShqiptareAlertDialog(true);
                    }}
                  />
                  <img className="p-2 rounded-3xl aspect-16/9 w-full" alt="Loan" src={language === 1 ? "./images/promotions/loan_en.png" : "./images/promotions/loan_al.png"} />
                  <img className="p-2 rounded-3xl aspect-16/9 w-full" alt="Merchant" src={language === 1 ? "./images/promotions/merchant_en.png" : "./images/promotions/merchant_al.png"} />
                </div>
              </div>
              {showPostaShqiptareAlertDialog && (
                <ActionDialog
                  open={showPostaShqiptareAlertDialog}
                  title={t("ALBANIAN_POST")}
                  onClose={() => {
                    setShowPostaShqiptareAlertDialog(false);
                  }}
                >
                  <div className="font-medium flex justify-center items-center text-center p-4">{t("ALBANIAN_POST_INSERT_INFO")}</div>
                </ActionDialog>
              )}
            </div>
          </div>
        </div>
      </div>
      {showSwitchWallet && (
        <BottomSheet
          open={showSwitchWallet}
          onClose={() => {
            setShowSwitchWallet(false);
          }}
          title={t("SWITCH_WALLET")}
        >
          <div className="flex w-full justify-center">
            <span className="font-medium text-lg my-5">{t("CONFIRM_SWITCHING_WALLET")}</span>
          </div>
          <div className="flex items-center justify-center mt-3 w-full">
            <Button
              className="bg-primary py-3 px-10 rounded-lg"
              onClick={() => {
                selectUserWallet(switchWalletContextId);
              }}
            >
              <span className="text-base font-medium text-white">{t("CONFIRM")}</span>
            </Button>
          </div>
        </BottomSheet>
      )}
      <BottomNav
        onQRScannerClicked={() => {
          setShowScanner(true);
        }}
      />
      {showScanner && (
        <QRScanner
          onScan={handleScanResult}
          onError={(msg) => {
            notification.error({ message: t("SCAN_FAILED") });
          }}
          onClose={() => {
            setShowScanner(false);
          }}
        ></QRScanner>
      )}
    </>
  );
}

export default DashboardMobile;
